"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _LocalsContext = _interopRequireDefault(require("../context/LocalsContext"));
var _replaceTranslation = _interopRequireDefault(require("../utils/replaceTranslation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useLocals(config) {
  var _useContext;
  const _locals = (_useContext = (0, _react.useContext)(_LocalsContext.default)) === null || _useContext === void 0 ? void 0 : _useContext[0];
  const [locals, setLocals] = (0, _react.useState)({});
  const [defaultLocals, setDefaultLocals] = (0, _react.useState)({});
  const {
    lang,
    fallback = "en",
    res
  } = config;
  (0, _react.useEffect)(() => {
    if (typeof _locals === "undefined") return;
    setLocals(_locals);
  }, [_locals]);
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(res[lang])) {
      setDefaultLocals(res[lang]);
    } else if (!(0, _isEmpty.default)(res[fallback])) {
      setDefaultLocals(res[fallback]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fallback, lang, res]);
  const resolveObject = (0, _react.useCallback)((path, data) => {
    var _text;
    let text = path.split(".").reduce(function (locals, name) {
      return locals === null || locals === void 0 ? void 0 : locals[name];
    }, locals);
    if (typeof text === "undefined") {
      text = path.split(".").reduce(function (locals, name) {
        return locals === null || locals === void 0 ? void 0 : locals[name];
      }, defaultLocals);
    }
    if (!(0, _isEmpty.default)(data)) {
      text = (0, _replaceTranslation.default)(text, data);
    }
    return (_text = text) !== null && _text !== void 0 ? _text : "";
  }, [defaultLocals, locals]);
  return function (param, data) {
    try {
      return resolveObject(param, data);
    } catch (error) {
      return "";
    }
  };
}
var _default = exports.default = useLocals;